import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';

import { Subject } from 'rxjs';
import { LoaderModel } from '../shared/loader/loader.model';


@Injectable()
export class DataService {

    loaderSubject: Subject<LoaderModel> = new Subject();
    loaderModel: LoaderModel = new LoaderModel();
    errorMsg: string = "";
    constructor(private httpClient: HttpClient,
        // private jwtHelper: JwtHelperService
    ) {
    }

    getHeaders() {
        const authToken = sessionStorage.getItem("authToken");
        if (authToken !== null && authToken !== "") {
            return new HttpHeaders({
                    "Authorization": 'Bearer ' + authToken,
                    "X-Frame-Options": 'DENY',
                    "Referrer-Policy": 'no-referrer',
                    "X-XSS-Protection": '1; mode=block',
                    "Content-Security-Policy": 'default-src https',
                    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
                    'X-Content-Type-Options': 'nosniff',
                    'Cache-control': 'no-store,max-age=0'
                })
             
        } else {
            return new HttpHeaders({
                    "X-Frame-Options": 'DENY',
                    "Referrer-Policy": 'no-referrer',
                    "X-XSS-Protection": '1; mode=block',
                    "Content-Security-Policy": 'default-src https',
                    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
                    'X-Content-Type-Options': 'nosniff',
                    'Cache-control': 'no-store,max-age=0'
                })
        }
    }


    login(url: string, param: any) {
        return this.httpClient.post(url, param, {headers: this.getHeaders()});
    }

    logout(url: string) {
        return this.httpClient.post(url, null, {headers: this.getHeaders()});
    }

    getAuthToekn() {

        let authToken = sessionStorage.getItem("authToken")?.toString();
        return authToken;
    }

    pbiGet(url: string, param?: string) {
        if (param !== undefined) {
            url = url + param;
        }
        return this.httpClient.get(url, {headers: this.getHeaders()});
    }

    get(url: string, param?: string) {
        if (param !== undefined) {
            url = url + param;
        }
        return this.httpClient.get(url, {headers: this.getHeaders()});
    }

    download(url: string) {
        return this.httpClient.post(url, null, {
            headers: this.getHeaders(),
            responseType: 'blob'
        },);
    }

    post(url: string, param: any) {

        return this.httpClient.post(url, param, {headers: this.getHeaders()});
    }
    patch(url: string, param: any) {

        return this.httpClient.patch(url, param, {headers: this.getHeaders()});
    }
    put(url: string, param: any) {

        return this.httpClient.put(url, param, {headers: this.getHeaders()});
    }
    delete(url: string) {
        return this.httpClient.delete(url, {headers: this.getHeaders()});
    }
}
